import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";
import { ContactFormType, ContactUsTypeResponse } from "types/contact";

export const ContactApi = {
  async submitContactForm(typename: string, payload: ContactFormType) {
    await axiosRequest.post<ApiResponse>(
      "",
      payloadHelper("submitContactForm", typename, payload)
    );
    return { status: 0, msg: "success" };
  },
  async contactUs() {
    const response = await axiosRequest.post<ContactUsTypeResponse>(
      "",
      payloadHelper("ContactUs", null, null)
    );
    return response.data;
  },
};
